module.exports = __webpack_public_path__ + "img/forumDetailsBj.afaf8739.png";